<template>
<div>

<div class="modal-content border border-success">
<div  style="background-color:#9acd32;color:black" class="modal-header border border-success text-nowrap ">
  <h4 class="modal-title ">
    <i style="color:blue" class="fas fa-cash-register mr-3" aria-hidden="true"></i>     
    <strong>STAMPA DOCUMENTO GESTIONALE</strong>
  </h4>  
</div>

<div class="modal-body border border-success">
  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
</div>

<div class="modal-footer">
    <button @click="$emit('close')" type="button" class="btn btn-outline-secondary ">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
        ANNULLA
    </button>

    <button  @click="postXML()" :disabled="bt_spinner==true" type="button" class="btn btn-primary ">
          <i class="fas fa-print mr-2" aria-hidden="true"></i>   
            STAMPA 
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    </button>    
</div>

</div>
</div>


</template>

<script>

//import { mapGetters } from 'vuex';


import axios             from 'axios'
import alertBox          from '@/components/common/AlertBox.vue'
import fmt               from '@/components/mixins/fmt'
import getSaleData       from '@/components/rt/mixins/getSaleData'


  export default {
  mixins : [fmt,getSaleData],
  props  : ['data'],

     components: {alertBox},
    data () {
      return {
        
          msg      : {title : '',body:'',type :0},
        
        
          items       : [],
          payments    : [],
          bt_spinner  : false
                                   
      }
    },

      
    async created () 
      {
        console.log('EPSON NOT FISCAL RECEIPT DATA',this.data)
        const data     = await this.getSaleData(this.data.saleId)
        this.items     = data[0]
        this.payments  = data[1]
        //this.getSaleData()
      },
    
    methods: 
    {
    
     getXML() 
     {
        
        //const crlf         =  '\r\n'  
        const maxLength    = 46  
      
        const spc          = ' '
        const description1 = 'ABBUONO'
        const description2 = 'TOTALE EURO '
        const description3 = 'euro'
        const notPaid    = this.payments.filter(item => item.typeId == 'CRED') 

                    let notPaidTotal = 0
                    notPaid.forEach(item => {
                        notPaidTotal += item.amount
                    })


        let xml = ''  
         
        const dataPayments   = this.payments.filter(item => item.typeId == 'ELEC' || item.typeId == 'PAGO' || item.typeId == 'SCAL') 
        let elecTotal = 0
            dataPayments.forEach(item=>{
              elecTotal += item.amount
            })
    

        let SubtotalAdjustment = this.items[0].total_discount
        this.payments.forEach(item=>{
              if(item.typeId == 'COUP')
              {
                SubtotalAdjustment += item.amount
              }
              if(item.typeId == 'CB')
              {
                SubtotalAdjustment += item.amount
              }
        })  
                    
        xml = '<printerNonFiscal><beginNonFiscal operator="1"/>'
       /* xml += '<Printer Num="1"/>'*/
        xml += '<printNormal operator="1" font="1"' + spc.repeat(maxLength - description3.length)  + description3 + '/>'            
        this.items.forEach(item => {      
            
            
            const total        = this.fmt1(item.price)
            const description1 = item.barcode + ' ' + item.category 
            const totalLength  = total.length
        
            xml += '<printNormal operator="1" font="1"' + description1 + spc.repeat(maxLength - description1.length -  totalLength)  +  total + '/>'
            if(Number(item.discount > 0))
            {
                const total = '-' + this.fmt1(item.discount_value)
                const description = 'SCONTO ART.'
                const totalLength  = total.length
                xml += '<printNormal operator="1" font="1"' + description + spc.repeat(maxLength - description.length -  totalLength)  +  total +  '/>'
                        
          }

      })
      
      const total        = this.fmt1(this.items[0].total)      
      const totalLength  = total.length
      xml += '<printNormal operator="1" font="1"/>'
      xml += '<printNormal operator="1" font="1"/>'
      
      xml += '<printNormal operator="1" font="3"' + description2 + spc.repeat(maxLength - description2.length - totalLength) + total  + '/>'

      if(SubtotalAdjustment > 0)
      {
        const total        = '-' + this.fmt1(SubtotalAdjustment)
        const totalLength  = total.length
        xml += '<printNormal operator="1" font="3"' + description1 + spc.repeat(maxLength - description1.length - totalLength) + total + '/>'
      }
      xml += '<printNormal operator="1" font="1" />'     
      xml += '<printNormal operator="1" font="1" />'   
  
      this.payments.forEach(item=>{
          if(item.typeId == 'CASH')
          {
            
            const total        = this.fmt1(item.amount)            
            const totalLength  = total.length
            const description  = 'PAGAMENTO CONTANTE'
            xml += '<printNormal operator="1" font="1"' + description + spc.repeat(maxLength - description.length -  totalLength)  +  total +  '/>'    
            
          }
          
        })   
        if(elecTotal > 0)
        {
            
            const total        = this.fmt1(elecTotal)            
            const totalLength  = total.length
            const description  = 'PAGAMENTO ELETTRONICO'
            xml += '<printNormal operator="1" font="1"' + description + spc.repeat(maxLength - description.length -  totalLength)  +  total +  '/>'
          
        }            
        if(notPaidTotal > 0) 
        {
          
            const total        = this.fmt1(notPaidTotal)            
            const totalLength  = total.length
            const description  = 'NON RISCOSSO'
            xml += '<printNormal operator="1" font="1"' + description + spc.repeat(maxLength - description.length -  totalLength)  +  total +  '/>'   
                    
        }
          
        xml += '<printNormal operator="1" font="1"' + '/>'      
        xml += '<printNormal operator="1" font="1"' + '/>'      
        
        
        xml += '<printBarCode  position="901" width="3" height="100" HRIPosition="1" HRIFont="A" codeType="69" code="' + "S" +  this.data.saleId + '"/>'
        xml += '<endNonFiscal operator="1" />' 
        xml += '</printerNonFiscal>' 
        
        
          
          
          console.log('EPSON NOT FISCAL CHECK',xml)  
          return xml              
      },
      getSOAP(xml)
      {
            const soap = '<?xml version="1.0" encoding="utf-8"?>\n' +
            '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">\n' +
              '<s:Body>\n' + xml +
            '</s:Body>\n' +
            '</s:Envelope>\n'
            return soap
      },
      postXML()
      {   this.bt_spinner = true
          const soap = this.getSOAP(this.getXML())
          axios({
               
               url    : this.data.url + '/cgi-bin/fpmate.cgi',
               method : 'post',
               data   : soap

             }).then(res => {
                this.bt_spinner = false
                console.log('Fiscal Printer Response',res)
               
                
             }).catch(err => {
                
                this.bt_spinner   = false   
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = err
                this.msg.type  = 1                          

               console.log('Error Fiscal Printer ',err)  
             })
       
      },    
         
   
     } 
      

    
  }
</script>
<style scoped>


.modal-footer {  
  justify-content: space-between;  
}


 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.modal-content
{
  width:  500px;
}
</style>
